import { Ref, useMemo } from 'react';
import Download from '~/icons/iconography/download.svg';
import { ShopTypes } from '~/lib/data-contract';
import { useTranslations } from '~/services/umbraco/hooks';
import { AccordionItem, AccordionItemRef } from '~/shared/components/Accordion';
import { LinkText, ListItem, ListWrapper } from './styled';

const ProductDocumentAccordion = ({
    product,
    ref,
}: {
    product?: ShopTypes.ProductQueryProduct;
    ref?: Ref<AccordionItemRef>;
}) => {
    const { translate } = useTranslations();
    const productDocuments = useMemo(
        () => [
            ...(product?.otherResources?.filter(
                (resource) => resource.resourceType !== 'PushedContent',
            ) || []),
            ...(product?.item?.otherResources?.filter(
                (resource) => resource.resourceType !== 'PushedContent',
            ) || []),
        ],
        [product],
    );

    if (!productDocuments.length && !product?.links?.length) {
        return null;
    }

    return (
        <AccordionItem ref={ref} id="productDocuments" header={translate('product.documentsTitle')}>
            {productDocuments?.length ? (
                <ListWrapper>
                    {productDocuments?.map(({ displayName, fileName, link }, index) => (
                        <ListItem key={`${displayName}${index}`}>
                            <Download />
                            <LinkText href={link!} rel="noreferrer noopener" target="_blank">
                                {displayName || fileName || 'document'}
                            </LinkText>
                        </ListItem>
                    ))}
                </ListWrapper>
            ) : null}

            {product?.links?.length ? (
                <ListWrapper>
                    {product.links?.map((link, index) => (
                        <ListItem key={`${link.name}${index}`}>
                            <LinkText
                                href={link.url!}
                                rel="noreferrer noopener"
                                target={link.target}
                            >
                                {link.name || 'link'}
                            </LinkText>
                        </ListItem>
                    ))}
                </ListWrapper>
            ) : null}
        </AccordionItem>
    );
};

export default ProductDocumentAccordion;
